import styled from 'styled-components';
import {flexColumnContainerMixin, flexRowReverseContainerMixin} from '../../../../themes/architecture/css-helpers/flex';

export const ButtonsWrapperDefaultBox = styled.div<{buttonsOnSeparateLines?: boolean;}>`
    max-width: 289px;
    width: 100%;
    margin: 5rem auto 0;
    ${({buttonsOnSeparateLines}) => buttonsOnSeparateLines ? flexColumnContainerMixin : flexRowReverseContainerMixin }
`;
